import { Component, ViewEncapsulation } from '@angular/core';
import {SharedDataService} from './shared-data.service';
import {ConfigurationDataService} from './configuration-data.service';
import {ModuleService} from './login/module.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  constructor (
    public shared : SharedDataService,
    private config : ConfigurationDataService,
    private module : ModuleService
  ) {}
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/app.component.ts